import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'plugins-multilanguage-icons',
  standalone: true,
  template: ` <span class="lang-icon lang-{{ lang }}"></span> `,
  styleUrl: './language-icons.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultilanguageIconsComponent {
  @Input() lang!: string;
}
